<div [ngStyle]="{'width': size, 'height': size}">
    <img *ngIf="user && user.avatar" src="{{src}}" class="avatar" [ngStyle]="{'width': size, 'height': size, 'object-fit':'cover'}" alt="user avatar" />

    <!-- <mat-icon class="material-icons-outlined" *ngIf="!user || !user.avatar"
        [ngStyle]="{'width': size, 'height': size, 'font-size': size}">{{src}}</mat-icon> -->
    <div *ngIf="!user || !user.avatar" class="no-avatar" [ngStyle]="{'width': size, 'height': size}" alt="user avatar"></div>
</div>
